export const setTheme = (theme) => {
    sessionStorage.setItem("theme", theme);
}

export const getTheme = () => {
    return sessionStorage.getItem("theme");
}


// 监听表格滚动
export const customHeaderStyle = (target) => {
    console.log(target, 'target');
    // const currentBody = target.bodyWrapper
    // currentBody.addEventListener('scroll', function (ev) {
    //     const scrollTop = ev.target.scrollTop
    //     console.log(scrollTop, target, 'ev');
    //     if (scrollTop > 10) {
    //         target.heaheaderRowClassName += 'darkHeader'
    //     } else {
    //         target.headerRowClassName = target.heaheaderRowClassName.split('darkHeader')[0]
    //     }
    // })
}

// 引擎截图
export const createViewportImg = async (waitTime = 100) => {
    const BlackHole3D = window.BlackHole3D;
    try {
        BlackHole3D.Graphics.setGeoCoordVisible(false);
        BlackHole3D.Graphics.setViewCubeVisible(false);
        BlackHole3D.Graphics.setSysUIPanelVisible(false);

        await new Promise(resolve => setTimeout(resolve, waitTime));

        const snapshot = BlackHole3D.getScreenSnapshot();

        BlackHole3D.Graphics.setGeoCoordVisible(true);
        BlackHole3D.Graphics.setViewCubeVisible(true);
        BlackHole3D.Graphics.setSysUIPanelVisible(true);

        return snapshot;
    } catch (error) {
        console.error('Viewport capture failed:', error);
        throw new Error('Failed to capture viewport snapshot');
    } finally {
        BlackHole3D.Graphics.setGeoCoordVisible(true);
        BlackHole3D.Graphics.setViewCubeVisible(true);
        BlackHole3D.Graphics.setSysUIPanelVisible(true);
    }
};